module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/fraternity-57af2d6827e9ce247efcfdc529dfe635.jpg";